import { Translatable } from "@icc/shared/helpers";

/** Zaslepka/zatyczka prowadnic */
export class RollerGuideCap {
    id: number;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    @Translatable({ model: 'WindowAccessories' })
    name?: string;
    img?: string;
    default: boolean;
    changed: boolean;
    profiles?: number[];
    colorGroupSetId?: number;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order?: number;

    /** Jedna zatyczka na prowadnicę */
    singlePerGuide?: boolean;

    doubleDoubleGuideCap?: boolean;

    /** Wspólna zatyczka dla dwóch pojedynczych prowadnic */
    sharedBetweenSingleGuides?: boolean;

    printCode?: string;
}

export interface IccRollerGuideCap {
    id: number;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    name?: string;
    img?: string;
    profiles?: number[];
    colorGroupSetId?: number;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order?: number;
    /** Jedna zatyczka na prowadnicę */
    singlePerGuide?: boolean;

    doubleDoubleGuideCap?: boolean;

    /** Wspólna zatyczka dla dwóch pojedynczych prowadnic */
    sharedBetweenSingleGuides?: boolean;

    printCode?: string;
}
